export default function SchedulerMobileJobList({
    children,
    emptyMessage,
    hasJobs,
    onClearFilter,
    showClearFilter = true,
}) {
    if (!hasJobs) {
        return (
            <div className="scheduler-mobile-empty-state">
                <span>
                    {emptyMessage}
                    {showClearFilter ? (
                        <>
                            <br />
                            <button
                                type="button"
                                className="btn btn-link p-0 align-baseline"
                                onClick={onClearFilter}
                            >
                                Try Clear Filter
                            </button>
                        </>
                    ) : null}
                </span>
            </div>
        );
    }

    return <div className="scheduler-mobile-job-list">{children}</div>;
}
